import P5SketchWithAudio from './P5SketchWithAudio'

function App() {
  return (
    <P5SketchWithAudio/>
  );
}

export default App;
